// TP1: PrimeVue 2.0.7 places an appendTo="body" panel in page coordinates and, when it flips the
// panel above its target, clamps the top at 0 - which on a scrolled page is above the window. Call
// this once the panel is open: it shifts the panel so it sits inside the window (top edge first).
// minTop: keep the panel's top below this (e.g. the fixed top bar, see topbarBottom; UI1c)
export function keepOverlayOnScreen(el, viewportHeight = window.innerHeight, minTop = 0) {
  if (!el || !el.style || typeof el.getBoundingClientRect !== 'function') return
  const rect = el.getBoundingClientRect()
  let shift = 0
  if (rect.bottom > viewportHeight) shift = viewportHeight - rect.bottom
  if (rect.top + shift < minTop) shift = minTop - rect.top
  if (shift !== 0) {
    const top = parseFloat(el.style.top) || 0
    el.style.top = (top + shift) + 'px'
  }
}

// UI1c: the bottom edge of the app's fixed top bar (60 px, drawn above appendTo="body" menus)
export function topbarBottom() {
  const bar = typeof document !== 'undefined' && document.querySelector('.layout-topbar')
  const bottom = bar && bar.getBoundingClientRect ? bar.getBoundingClientRect().bottom : 0
  return bottom > 0 ? bottom : 0
}
